//REACT
import * as React from "react";
//MATERIAL UI COMPONENTS
import {
  withTheme,
  Typography,
  withStyles,
  AppBar,
  Toolbar,
  IconButton,
  ListItem,
  List,
  ListItemIcon
} from "@material-ui/core";
import PropTypes from "prop-types";
//STYLE
import "./regStyles.css";
import { Close, Brightness1, PanoramaFishEye } from "@material-ui/icons";
//COMPONENTS

class PrivacyPolicy extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { classes } = this.props;

    return (
      <>
        <AppBar className="accountAppBar">
          <Toolbar className="accountToolbar">
            <div className="accountAppBarContentContainer">
              <div className="accountAddressContainer">
                <Typography
                  component="h4"
                  variant="h5"
                  style={{ color: "white" }}
                >
                  Privacy Policy
                </Typography>
              </div>
            </div>
            <div className="accountCloseButtonContainer">
              <IconButton
                color="inherit"
                onClick={() => this.props.history.goBack()}
                aria-label="Close"
                className="accountAppBar"
              >
                <Close />
              </IconButton>
            </div>
          </Toolbar>
        </AppBar>
        <div className="privacyPolicy_screenContainer">
          <Typography variant={"h4"} align={"center"}>
            FOOD FOREST PRIVACY POLICY
          </Typography>
          <Typography variant={"h5"} align={"center"}>
            Effective: May 1, 2019
          </Typography>
          <Typography
            className={classes.paragraph}
            variant={"body2"}
            align={"left"}
          >
            Thank you for using the Food Forest Services! We are committed to
            providing you the best online shopping and hot spot delivery
            experience possible. This Privacy Policy explains what information
            we (Food Forest LLC) collect, how that information is used, under
            what circumstances we share information, and the choices you can
            make about that information. This Privacy Policy applies whether you
            access the Food Forest Services (as defined in the Terms of Service)
            through a browser, a mobile application, or any other method.
          </Typography>
          <Typography
            className={classes.paragraph}
            variant={"body2"}
            align={"left"}
          >
            This Privacy Policy also describes how we collect, use and disclose
            your personally identifiable information ("PII"), including
            personally identifiable health or medical information ("Personal
            Health Information" or "PHI"). PII is information about you that may
            be used to identify you (such as your name, phone number, or
            address). Personal Health Information is PII combined with
            information that relates to (a) your past, present, or future
            physical or mental health or condition, (b) the provision of health
            care to you, or (c) your past, present, or future payment for the
            provision of health care.
          </Typography>
          <Typography
            className={classes.paragraph}
            variant={"body2"}
            align={"left"}
          >
            Under California Civil Code § 1798.83, California residents may
            request a notice identifying the categories of personal information
            which we share with certain third parties for direct marketing
            purposes under certain circumstances and providing contact
            information for such third parties. If you are a California resident
            and would like a copy of this notice, please submit a written
            request to us at the address provided below under the Section
            entitled "Contact Information."
          </Typography>
          <Typography
            className={classes.sectionTitles}
            variant={"body1"}
            align={"left"}
          >
            Information we collect
          </Typography>
          <Typography
            className={classes.sectionTitles}
            variant={"body1"}
            align={"left"}
          >
            <i>
              1. Information you provide to us or allow others to provide to us
            </i>
          </Typography>
          <Typography
            className={classes.paragraph}
            variant={"body2"}
            align={"left"}
          >
            At various points in the Food Forest experience, you may provide us
            with information about yourself. For example, when you create an
            account through the Services, you provide us with personal
            information like your name, email address, and zip or postal code.
            And if you place an order through the Services, we collect
            information including your address, phone number, birth date (for
            alcohol orders or prescription delivery, where available), credit
            card information, vehicle license plate number(s) (for hot spot
            pickup identification) and the details of your order. Your account
            information may be updated or corrected by accessing your account
            settings.
          </Typography>
          <Typography
            className={classes.paragraph}
            variant={"body2"}
            align={"left"}
          >
            If you use the Services for prescription delivery (where available),
            the third- party pharmacy processing your prescription will provide
            to your name, address, email address, birth date, phone number, the
            total amount being charged to you for the prescription drug
            product(s), and sales tax information for the prescription drug
            product(s) (if applicable). The third-party pharmacy will also share
            whether or not the prescription drug product you have ordered
            requires temperature control. If a prescription drug product
            delivered to you through the Services has been recalled, the
            third-party pharmacy will share your name, email address, the date
            of the prescription drug product order, and the total amount to be
            refunded to you with Food Forest. The pharmacy will not disclose to
            us the name, quantity, manufacturer or distributor of the
            prescription drug you have ordered or any other PHI about you other
            than your status as a patient of the pharmacy.
          </Typography>
          <Typography
            className={classes.paragraph}
            variant={"body2"}
            align={"left"}
          >
            If you log into the Services through a third-party service, both we
            and that third-party may receive some information about you and your
            use of the services. For example, if you choose to log into the
            Services with your Facebook account, we may receive information from
            Facebook, such as your name, e-mail address, public profile
            information, and information about your contacts. We may also offer
            social sharing tools (such as the Facebook “Like” button) that let
            you share actions on the Services with other websites and vice
            versa. In those cases, the providers of those tools may receive
            information about you when you use those tools. You should check the
            privacy policies of these third-party services and your settings
            there for more information.
          </Typography>
          <Typography
            className={classes.paragraph}
            variant={"body2"}
            align={"left"}
          >
            If you wish to invite your friends and contacts to use the Services,
            we may give you the option of either entering in their contact
            information manually or, for United States residents, importing it
            from your address books on other third-party services. In both
            cases, we will store this information for the sole purposes of
            allowing you to send your friends referral offers, for determining
            whether your friends use the Services after a referral is sent, and,
            for United States residents, to remind your friends of the referral
            sent on your behalf.
          </Typography>
          <Typography
            className={classes.paragraph}
            variant={"body2"}
            align={"left"}
          >
            Our partners may let us collect information about use of their
            sites/apps or share such information with us. For example, if you
            use a Food Forest button or widget on another site or app, we may
            receive information about your use of that button or widget and the
            third-party site/app.
          </Typography>
          <Typography
            className={classes.paragraph}
            variant={"body2"}
            align={"left"}
          >
            Our Services are not intended for children under 13 years of age,
            and we do not knowingly collect personal information from children
            under the age of 13. If we obtain actual knowledge that any
            information we collect has been provided by a child under the age of
            13, we will delete that information.
          </Typography>
          <Typography
            className={classes.sectionTitles}
            variant={"body1"}
            align={"left"}
          >
            Location Information:
          </Typography>
          <Typography
            className={classes.paragraph}
            variant={"body2"}
            align={"left"}
          >
            When you use the Services, we may collect precise location data. For
            instance, if you allow the Services to access location services
            through the permission system used by your device's mobile operating
            system or browser, we may collect the precise location of your
            device. We use your location information to facilitate the prompt
            hand-off of pickup orders (where available), to assist you in
            finding nearby hot spots for which pickup or delivery are available,
            for other similar purposes and for analytics purposes.
          </Typography>
          <Typography
            className={classes.paragraph}
            variant={"body2"}
            align={"left"}
          >
            You can choose whether or not to enable the location tracking
            feature through the settings on your device or browser, or when
            prompted by the Food Forest mobile app. We may also infer your
            general location information, for example by using your internet
            protocol (IP) address.
          </Typography>
          <Typography
            className={classes.sectionTitles}
            variant={"body1"}
            align={"left"}
          >
            <i>2. Technical information about usage of the Services</i>
          </Typography>

          <Typography
            className={classes.paragraph}
            variant={"body2"}
            align={"left"}
          >
            When you use the Services, either through a browser or mobile app,
            we automatically receive some technical information about the
            hardware and software that is being used.
          </Typography>
          <Typography
            className={classes.sectionTitles}
            variant={"body1"}
            align={"left"}
          >
            Cookies, Pixels, and Other Tracking Technologies:
          </Typography>
          <Typography
            className={classes.paragraph}
            variant={"body2"}
            align={"left"}
          >
            We, our partners, our advertisers, and third-party advertising
            networks use various technologies to collect information, including
            but not limited to cookies, pixels, scripts, and device identifiers.
            Cookies are small text files that are sent by your computer when you
            access our services through a browser. We, our partners, our
            advertisers, and third party advertising networks may use session
            cookies (which expire when you close your browser), persistent
            cookies (which expire when you choose to clear them from your
            browser), pixels, scripts, and other identifiers to collect
            information from your browser or device that helps us do things such
            as understand how you use our services and other services;
            personalize your experience; measure, manage, and display
            advertising on the Services or on other services; understand your
            usage of the Services and other services in order to serve
            customized ads and remember that you are logged into the Services.
            By using your browser settings, you may block cookies or adjust
            settings for notifications when a cookie is set.
          </Typography>
          <Typography
            className={classes.paragraph}
            variant={"body2"}
            align={"left"}
          >
            We employ some third-party services to help us understand the usage
            of the Services and the performance of advertising, and these
            third-parties may also deploy cookies, pixels, or other identifiers
            on the Services or collect information through our mobile
            applications. For example, we use Google Analytics to understand, in
            a non-personal way, how users interact with various portions of the
            Services --{" "}
            <a href="http://www.google.com/policies/privacy/">
              you can learn more about information that Google may collect here
            </a>
            .
          </Typography>
          <Typography
            className={classes.sectionTitles}
            variant={"body1"}
            align={"left"}
          >
            Log information:
          </Typography>

          <Typography
            className={classes.paragraph}
            variant={"body2"}
            align={"left"}
          >
            When you use the Services, our servers will record information about
            your usage of the Services and information that is sent by your
            browser or device. Log information can include things like the IP
            address of your device, information about the browser, operating
            system and/or app you are using, unique device identifiers, pages
            that you navigate to and links that you click, searches that you run
            on the Services, and other ways you interact with the Services. If
            you are logged into the Services, this information is stored with
            your account information.
          </Typography>
          <Typography
            className={classes.sectionTitles}
            variant={"body1"}
            align={"left"}
          >
            Interest-Based or Online Behavioral Advertising:
          </Typography>

          <Typography
            className={classes.paragraph}
            variant={"body2"}
            align={"left"}
          >
            Food Forest may use third-party advertising companies to serve
            interest-based advertisements to you. These companies compile
            information from various online sources (including mobile-enabled
            browsers and applications) to match you with ads that will be the
            most relevant, interesting, and timely for you. If you would like to
            opt-out of interest-based advertising, please visit{" "}
            <a href="http://optout.networkadvertising.org/#/ ">
              http://optout.networkadvertising.org/#/{" "}
            </a>
            . Please note that you will be opted out of all interest-based
            advertising from all business members of the Network Advertising
            Initiative for that specific browser on that specific device. If you
            opt-out, you may continue to see Food Forest’s or our partners’
            online advertisements; however, these ads will not be as relevant to
            you.
          </Typography>
          <Typography
            className={classes.sectionTitles}
            variant={"body1"}
            align={"left"}
          >
            How we use your information
          </Typography>
          <List>
            <ListItem classes={{ root: classes.listItem }}>
              <Typography
                className={classes.listItem_Paragraph}
                variant={"body2"}
                align={"left"}
              >
                We may use the information we collect for various purposes,
                including to:
              </Typography>
            </ListItem>
            <ListItem classes={{ root: classes.listItem_indent }}>
              <ListItemIcon classes={{ root: classes.listItem_icon }}>
                <Brightness1 style={{ fontSize: 10 }} />
              </ListItemIcon>
              <Typography
                className={classes.listItem_Paragraph}
                variant={"body2"}
                align={"left"}
              >
                Provide the Services to you, improve the quality of the service,
                and develop new products and services
              </Typography>
            </ListItem>
            <ListItem classes={{ root: classes.listItem_indent }}>
              <ListItemIcon classes={{ root: classes.listItem_icon }}>
                <Brightness1 style={{ fontSize: 10 }} />
              </ListItemIcon>
              <Typography
                className={classes.listItem_Paragraph}
                variant={"body2"}
                align={"left"}
              >
                Allow your Personal Shopper (which means those that shop for
                and/or deliver the order for you, including Food Forest and our
                retail partner and their employees/agents where applicable or
                our third-party providers) to choose your items at one of many
                potential retailer fulfillment sites, deliver your items to you,
                and/or call or text you with any updates or issues
              </Typography>
            </ListItem>
            <ListItem classes={{ root: classes.listItem_indent }}>
              <ListItemIcon classes={{ root: classes.listItem_icon }}>
                <Brightness1 style={{ fontSize: 10 }} />
              </ListItemIcon>
              <Typography
                className={classes.listItem_Paragraph}
                variant={"body2"}
                align={"left"}
              >
                Charge you for the purchase and delivery costs through one or
                more payment processing partners
              </Typography>
            </ListItem>
            <ListItem classes={{ root: classes.listItem_indent }}>
              <ListItemIcon classes={{ root: classes.listItem_icon }}>
                <Brightness1 style={{ fontSize: 10 }} />
              </ListItemIcon>
              <Typography
                className={classes.listItem_Paragraph}
                variant={"body2"}
                align={"left"}
              >
                Offer you customized content (including advertising, coupons,
                and promotions)
              </Typography>
            </ListItem>
            <ListItem classes={{ root: classes.listItem_indent }}>
              <ListItemIcon classes={{ root: classes.listItem_icon }}>
                <Brightness1 style={{ fontSize: 10 }} />
              </ListItemIcon>
              <Typography
                className={classes.listItem_Paragraph}
                variant={"body2"}
                align={"left"}
              >
                Understand how users interact with the Services (including
                advertising both on and off the Services) as a whole and to test
                new features or changes in our features
              </Typography>
            </ListItem>
            <ListItem classes={{ root: classes.listItem_indent }}>
              <ListItemIcon classes={{ root: classes.listItem_icon }}>
                <Brightness1 style={{ fontSize: 10 }} />
              </ListItemIcon>
              <Typography
                className={classes.listItem_Paragraph}
                variant={"body2"}
                align={"left"}
              >
                Provide customer service, respond to your communications and
                requests, and contact you about your use of the Services
              </Typography>
            </ListItem>
          </List>
          <Typography
            className={classes.paragraph}
            variant={"body2"}
            align={"left"}
          >
            You can opt-out of receiving promotional communications from Food
            Forest by using the settings on the Account Info page or by using
            the unsubscribe mechanism included in the message, where applicable.
          </Typography>
          <Typography
            className={classes.sectionTitles}
            variant={"body1"}
            align={"left"}
          >
            What we share
          </Typography>
          <Typography
            className={classes.paragraph}
            variant={"body2"}
            align={"left"}
          >
            The Services comprise a platform that presents you with a set of
            grocery catalogs from which you can select goods for picking,
            packing, and delivery by individual Personal Shopper(s) to your hot
            spot location or, if available, for you to pick up at a designated
            location. In order to make this work, we need to share information
            about you and your order with the other parties who help enable the
            service. This includes, for example, the Personal Shopper(s) who
            pick and deliver your order, the payment processing partner(s) that
            we use to validate and charge your credit card, and the retail
            grocery fulfillment partner(s) from whom we are purchasing goods on
            your behalf. To be clear, only our payment processing partner(s)
            receive credit card information.
          </Typography>

          <List>
            <ListItem classes={{ root: classes.listItem }}>
              <Typography
                className={classes.listItem_Paragraph}
                variant={"body2"}
                align={"left"}
              >
                We also share information under the following principles:
              </Typography>
            </ListItem>
            <ListItem classes={{ root: classes.listItem_indent }}>
              <ListItemIcon classes={{ root: classes.listItem_icon }}>
                <Brightness1 style={{ fontSize: 10 }} />
              </ListItemIcon>
              <Typography
                className={classes.listItem_Paragraph}
                variant={"body2"}
                align={"left"}
              >
                <i>With your consent or at your direction</i> — We will share
                your information with entities outside of the Services when we
                have your consent to do so or it is done at your direction. For
                example:
              </Typography>
            </ListItem>
            <ListItem classes={{ root: classes.listItem_indent_indent }}>
              <ListItemIcon classes={{ root: classes.listItem_icon }}>
                <PanoramaFishEye style={{ fontSize: 10 }} />
              </ListItemIcon>
              <Typography
                className={classes.listItem_Paragraph}
                variant={"body2"}
                align={"left"}
              >
                If you share a recipe publicly on the Services, it is viewable
                by anyone along with your first name and last initial.
              </Typography>
            </ListItem>
            <ListItem classes={{ root: classes.listItem_indent_indent }}>
              <ListItemIcon classes={{ root: classes.listItem_icon }}>
                <PanoramaFishEye style={{ fontSize: 10 }} />
              </ListItemIcon>
              <Typography
                className={classes.listItem_Paragraph}
                variant={"body2"}
                align={"left"}
              >
                If you invite friends to use the Services through our referral
                program or to share a shopping cart, we will share some
                information with the friends you invite like your name and
                picture. Likewise, if you choose to join someone else’s cart,
                they will see some of your information.
              </Typography>
            </ListItem>
            <ListItem classes={{ root: classes.listItem_indent }}>
              <ListItemIcon classes={{ root: classes.listItem_icon }}>
                <Brightness1 style={{ fontSize: 10 }} />
              </ListItemIcon>
              <Typography
                className={classes.listItem_Paragraph}
                variant={"body2"}
                align={"left"}
              >
                <i>With our retail fulfillment partners</i> — We may share your
                information with our retail partners in order to provide and
                maintain the Services.
              </Typography>
            </ListItem>
            <ListItem classes={{ root: classes.listItem_indent }}>
              <ListItemIcon classes={{ root: classes.listItem_icon }}>
                <Brightness1 style={{ fontSize: 10 }} />
              </ListItemIcon>
              <Typography
                className={classes.listItem_Paragraph}
                variant={"body2"}
                align={"left"}
              >
                <i>For external processing or service provision</i> — We
                sometimes share information with third parties to process
                information on our behalf or to otherwise provide certain
                services (such as delivery services, advertising services, or
                information to better tailor our services to you). For the
                purposes of this processing or provision of services, we may
                share your information with such third parties under appropriate
                confidentiality provisions.
              </Typography>
            </ListItem>
            <ListItem classes={{ root: classes.listItem_indent }}>
              <ListItemIcon classes={{ root: classes.listItem_icon }}>
                <Brightness1 style={{ fontSize: 10 }} />
              </ListItemIcon>
              <Typography
                className={classes.listItem_Paragraph}
                variant={"body2"}
                align={"left"}
              >
                <i>For legal purposes</i> — We may share your information when
                we believe that the disclosure is reasonably necessary to (a)
                comply with applicable laws, regulations, legal process, or
                requests from law enforcement or regulatory authorities, (b)
                prevent, detect, or otherwise handle fraud, security, or
                technical issues, and (c) protect the safety, rights, or
                property of any person, the public, or Food Forest.
              </Typography>
            </ListItem>
            <ListItem classes={{ root: classes.listItem_indent }}>
              <ListItemIcon classes={{ root: classes.listItem_icon }}>
                <Brightness1 style={{ fontSize: 10 }} />
              </ListItemIcon>
              <Typography
                className={classes.listItem_Paragraph}
                variant={"body2"}
                align={"left"}
              >
                <i>On a non-personal or aggregate basis</i> — We share
                information on both a non-personally identifying basis
                (including, but not limited to, order and delivery details but
                not including credit card information) or an aggregate basis.
              </Typography>
            </ListItem>
            <ListItem classes={{ root: classes.listItem_indent }}>
              <ListItemIcon classes={{ root: classes.listItem_icon }}>
                <Brightness1 style={{ fontSize: 10 }} />
              </ListItemIcon>
              <Typography
                className={classes.listItem_Paragraph}
                variant={"body2"}
                align={"left"}
              >
                <i>
                  To enable purchase of alcohol (not available in all
                  jurisdictions)
                </i>{" "}
                — When you buy alcohol using the Services, we may be required by
                law to share certain information with the retailer who makes the
                sale. This information could include, among other things, the
                names and addresses of the purchaser and recipient, government
                issued ID information, the quantity, brand, price, proof, and
                volume of alcohol purchased, and a recipient signature.
              </Typography>
            </ListItem>
            <ListItem classes={{ root: classes.listItem_indent }}>
              <ListItemIcon classes={{ root: classes.listItem_icon }}>
                <Brightness1 style={{ fontSize: 10 }} />
              </ListItemIcon>
              <Typography
                className={classes.listItem_Paragraph}
                variant={"body2"}
                align={"left"}
              >
                <i>For business purposes</i> — We may share your information in
                connection with, or during negotiations of, any merger, sale of
                company assets, financing or acquisition of all or a portion of
                our business by another company. We may also share your
                information between and among Food Forest, and its current and
                future parents, affiliates, subsidiaries, and other companies
                under common control and ownership.
              </Typography>
            </ListItem>
          </List>
          <Typography
            className={classes.sectionTitles}
            variant={"body1"}
            align={"left"}
          >
            Personal Health Information
          </Typography>
          <Typography
            className={classes.paragraph}
            variant={"body2"}
            align={"left"}
          >
            This Section (Personal Health Information) governs our use and
            disclosure of your Personal Health Information. If there is a
            conflict between the terms of this Section and any other terms of
            this Privacy Policy or the Food Forest Terms of Services, the terms
            in this Section will govern. To the extent we receive, create,
            maintain, use or disclose any of your PHI, we will maintain the
            privacy and security of such information as required by the federal
            patient privacy law known as the Health Insurance Portability and
            Accountability Act and the regulations promulgated under that Act
            ("HIPAA"), as well as any applicable state and other federal privacy
            policy laws.
          </Typography>
          <Typography
            className={classes.paragraph}
            variant={"body2"}
            align={"left"}
          >
            Your PHI is protected under HIPAA and under certain state laws.
            Those laws give you rights with respect to the access, use, and
            disclosure of PHI by your health care providers, such as pharmacies,
            and us. In the future, when available, and when you place a pharmacy
            order using our Services, the pharmacy responds as we have described
            above under the Section entitled "Information we collect" by
            disclosing to Food Forest your status as a patient of the pharmacy.
            Information concerning your status as a patient of the pharmacy is
            PHI and protected by HIPAA. As discussed above, no other PHI will be
            disclosed to us by your pharmacy and no other PHI will be disclosed
            by Food Forest to your personal shopper other than your status as a
            patient of the pharmacy. For a more complete description of your
            rights under HIPAA and the uses and disclosures of your PHI, please
            refer to your pharmacy's Notice of Privacy Practices. We will not
            disclose your PHI without your prior written consent with other
            people or non-affiliated companies unless: (i) it is needed to
            provide our Services, (ii) it has been "de-identified" so that it
            cannot identify you, (ii) we have your prior written consent, (iv)
            disclosure is required by law, or (v) we are acquired or file for
            bankruptcy.
          </Typography>
          <Typography
            className={classes.sectionTitles}
            variant={"body1"}
            align={"left"}
          >
            <u>Security</u>
          </Typography>
          <Typography
            className={classes.paragraph}
            variant={"body2"}
            align={"left"}
          >
            We employ administrative, physical, and technical measures designed
            to safeguard and protect information under our control from
            unauthorized access, use, and disclosure. These measures include
            encrypting your communications by utilizing Secure Sockets Layer
            ("SSL") software and using a secure messaging service when we send
            your PHI electronically. In addition, when we collect, maintain,
            access, use, or disclose your PHI, we will do so using systems and
            processes consistent with information privacy and security
            requirements under applicable federal and state laws, including,
            without limitation, HIPAA. All electronic PHI will be encrypted at
            rest and in transit.
          </Typography>
          <Typography
            className={classes.paragraph}
            variant={"body2"}
            align={"left"}
          >
            We will make any legally required notifications of any breach of the
            security, confidentiality, or integrity of your PHI or PII,
            including, without limitation, breaches of your stored PHI or PII
            (as breaches are defined under applicable state or federal statutes
            on security breach notification). To the extent permitted by
            applicable laws, we will make such notifications to you in the most
            expedient time possible and without unreasonable delay, insofar as
            consistent with (i) the legitimate needs of law enforcement or (ii)
            any measures necessary to determine the scope of the breach and
            restore the reasonable integrity of the data system.
          </Typography>
          <Typography
            className={classes.sectionTitles}
            variant={"body1"}
            align={"left"}
          >
            Changes to this Policy
          </Typography>

          <Typography
            className={classes.paragraph}
            variant={"body2"}
            align={"left"}
          >
            This policy may change from time to time and any revised Privacy
            Policy will be posted at this page, so we encourage you to review it
            regularly. If we make changes, we will notify you by revising the
            date at the top of this Privacy Policy and, in the case of materials
            changes to the Privacy Policy, we may provide you with additional
            notice (such as a notice in our user interface or sending you a
            notification by email).
          </Typography>
          <Typography
            className={classes.sectionTitles}
            variant={"body1"}
            align={"left"}
          >
            For Residents of California
          </Typography>

          <Typography
            className={classes.paragraph}
            variant={"body2"}
            align={"left"}
          >
            If you are a California resident, you may ask Food Forest for a
            notice describing what categories of personal information Food
            Forest shares with third parties or affiliates for those third
            parties or affiliates’ direct marketing purposes and identify the
            name and address of the third parties that received such personal
            information. Please submit a written request to the address provided
            below and specify that you want a copy of your California Privacy
            Rights Notice.
          </Typography>

          <Typography
            className={classes.paragraph}
            variant={"body2"}
            align={"left"}
          >
            Under California Civil Code Section 1789.3, California residents are
            entitled to the following specific consumer rights notice: If you
            have a question or complaint regarding the Website, please send an
            email to legal@FoodForest.com. You may also contact us by writing to
            us at the address provided below under the Section entitled "Contact
            Information." California residents may reach the Complaint
            Assistance Unit of the Division of Consumer Services of the
            California Department of Consumer Affairs may be contacted in
            writing at 400 R Street, Suite 1080, Sacramento, California 95814,
            or by telephone at (916) 445-1254 or (800) 952-5210.
          </Typography>

          <Typography
            className={classes.sectionTitles}
            variant={"body1"}
            align={"left"}
          >
            Contact Information
          </Typography>

          <Typography
            className={classes.paragraph}
            variant={"body2"}
            align={"left"}
          >
            Questions or comments about our Privacy Policy? Contact our Legal
            department at:
          </Typography>
          <Typography variant={"body2"} align={"left"}>
            Food Forest
          </Typography>
          <Typography variant={"body2"} align={"left"}>
            ATTN: Legal Department
          </Typography>
          <Typography variant={"body2"} align={"left"}>
            120 Chambers Road, Suite 206
          </Typography>
          <Typography variant={"body2"} align={"left"}>
            Columbus, OH 43212
          </Typography>
          <Typography variant={"body2"} align={"left"}>
            legal@FoodForest.com
          </Typography>
          <Typography variant={"body2"} align={"left"}>
            1 (513) 284-0299
          </Typography>

          <Typography
            className={classes.paragraph}
            variant={"body2"}
            align={"left"}
          >
            For customer service inquiries, please review Your Account Settings,
            visit Food Forest’s Help Center, or call our Community Operations
            team at 1 (513) 284-0299.
          </Typography>

          <Typography
            className={classes.sectionTitles}
            variant={"body1"}
            align={"left"}
          >
            Last Updated: April 16, 2019
          </Typography>

          <Typography
            className={classes.sectionTitles}
            variant={"body1"}
            align={"left"}
          />

          <Typography
            className={classes.paragraph}
            variant={"body2"}
            align={"left"}
          />
        </div>
      </>
    );
  }
}

PrivacyPolicy.propTypes = {
  classes: PropTypes.object.isRequired
};

const styles = theme => ({
  paragraph: {
    padding: "10px 0"
  },
  sectionTitles: {
    padding: "10px 0",
    fontWeight: 600
  },
  listItem: {},
  listItem_icon: {
    display: "flex",
    alignSelf: "flex-start",
    padding: "7px 0 0 0 "
  },
  listItem_indent: {
    padding: "0 0 0 60px"
  },
  listItem_indent_indent: {
    padding: "0 0 0 120px"
  },
  listItem_Paragraph: {
    padding: "2px 0"
  }
});

export default withTheme()(withStyles(styles)(PrivacyPolicy));
